// src/components/YouTubeVideoDisplay.js
import React from "react";
import YouTube from "react-youtube";

export default function YouTubeVideoDisplay({ videoUrl, onEnded }) {
  // извлекаем ID из embed-URL
  const videoId = videoUrl.split("/embed/")[1].split("?")[0];

  const opts = {
    width: "100%",
    height: "100%",
    playerVars: {
      autoplay: 1,
      controls: 1,
      rel: 0,              // отключаем «рекомендованные видео» с других каналов
      modestbranding: 1,   // минимизируем брендинг YouTube
      iv_load_policy: 3,   // отключаем подсказки-аннотации
    },
  };

  const _onStateChange = (event) => {
    if (event.data === window.YT.PlayerState.ENDED) {
      onEnded();
    }
  };

  return (
    // Контейнер для сохранения соотношения сторон 16:9
    <div className="relative w-full pb-[56.25%]">
      <YouTube
        videoId={videoId}
        opts={opts}
        onStateChange={_onStateChange}
        className="absolute top-0 left-0 w-full h-full"
      />
    </div>
  );
}
